export default __webpack_public_path__ + "assets/svg/dumbell.34e02b299a5ba89f98783d81b7a232e6.svg";